module.exports = __webpack_public_path__ + "media/newstyle/images/twitter-774c453600aa079325eddd781ad373c4.svg";